import { AssetTransaction } from 'appDtos';
import { useState } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { AlertComponent } from '../../shared/components';
import { formatDate, mapColor } from '../../shared/utils/utils';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { Icon } from '../../shared/components';
import { ReviewAction, ReviewModal, ReviewType } from './ReviewModal';

type Props = {
    triggerRevert: (id: number) => void;
    refreshAssetDetail: () => void;
    printing?:boolean;
    assetTransactions: AssetTransaction[];
};

export function Transactions({printing, refreshAssetDetail, triggerRevert, assetTransactions }: Props) {
    const [reviewAction, setReviewAction] = useState<ReviewAction>({ reviewType: ReviewType.NONE, transactionId: 0 });
    const setReviewType = (transactionId: number, reviewType: ReviewType) => setReviewAction({ ...reviewAction, transactionId, reviewType });

    const handleUpdate = () => {
        refreshAssetDetail();
    }

    return (
        <>
            {Boolean(assetTransactions?.length) &&
                <div className="table-responsive">
                    <ListGroup style={{ minWidth: '800px' }}>
                        <ListGroup.Item key="header" as="li" className="d-flex justify-content-left align-items-baseline transaction-card">
                            <div className="col-1 fw-bold" style={{ minWidth: '40px' }}>#</div>
                            <div className="col fw-bold" style={{ minWidth: '120px' }}>Created By</div>
                            <div className="col fw-bold" style={{ minWidth: '100px' }}>Date</div>
                            <div className="col fw-bold" style={{ minWidth: '120px' }}>Type</div>
                            <div className="col fw-bold" style={{ minWidth: '100px' }}>Status</div>
                            <div className="col fw-bold" style={{ minWidth: '100px' }}>Reviewer</div>
                            {!printing && <div className="fw-bold" style={{ width: '160px', flexShrink: 1, minWidth: '130px', maxWidth: '160px' }}></div>}
                        </ListGroup.Item>
                        {assetTransactions?.map((a, i) => (
                            <ListGroup.Item key={a.assetTransactionId} as="li" className="d-flex justify-content-left align-items-start transaction-card">
                                <div className="col-1" style={{ minWidth: '40px' }}>{i + 1}</div>
                                <div className="col" style={{ minWidth: '120px' }}>{a.createdBy}</div>
                                <div className="col" style={{ minWidth: '100px' }}>{formatDate(a.date)}</div>
                                <div className="col" style={{ minWidth: '120px' }}>{a.type}</div>
                                <div className={`col ${!printing ? mapColor(a.status): ''}`} style={{ minWidth: '100px' }}>{a.status}</div>
                                <div className="col" style={{ minWidth: '100px' }}>{a.reviewBy ?? 'N/A'}</div>
                                {!printing && <div className="d-flex justify-content-end align-items-center" style={{ width: '160px', flexShrink: 1, minWidth: '130px', maxWidth: '160px', flexWrap: 'wrap', gap: '4px', paddingLeft: '4px' }}>
                                    {a.canRevert && <Button onClick={() => triggerRevert(a.assetTransactionId)} className="btn btn-sm btn-warning fw-bold" style={{ whiteSpace: 'nowrap', flexShrink: 0, padding: '0.25rem 0.5rem' }}>Revert</Button>}
                                    {a.isReviewable && <Button onClick={() => setReviewType(a.assetTransactionId, ReviewType.REJECT)} variant="warning" size='sm' className="fw-bold" style={{ whiteSpace: 'nowrap', flexShrink: 0, padding: '0.25rem 0.5rem' }}>
                                        <Icon icon={faThumbsDown} /> <span className="d-none d-sm-inline">{ReviewType.REJECT}</span>
                                    </Button>}
                                    {a.isReviewable && <Button onClick={() => setReviewType(a.assetTransactionId, ReviewType.APPROVE)} variant="success" size='sm' className="fw-bold" style={{ whiteSpace: 'nowrap', flexShrink: 0, padding: '0.25rem 0.5rem' }}>
                                        <Icon icon={faThumbsUp} /> <span className="d-none d-sm-inline">{ReviewType.APPROVE}</span>
                                    </Button>}
                                </div>}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            }
            {(assetTransactions?.length === 0) && <AlertComponent message="No activity has been created." variant="info" />}
            <ReviewModal
                reviewAction={reviewAction}
                show={reviewAction.reviewType !== ReviewType.NONE}
                okHandler={handleUpdate}
                cancelHandler={() => setReviewType(0, ReviewType.NONE)}
            />
        </>
    );
}
